let GA_TRACKING_ID;
const gtagInit = (trackingId) => {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return;
  }
  if (document.getElementById("gtag-script") || !trackingId) {
    return;
  }
  GA_TRACKING_ID = trackingId;
  const external = document.createElement("script");
  external.async = true;
  external.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  external.id = "gtag-script";
  document.body.appendChild(external);
  const inline = document.createElement("script");
  inline.id = "gtag-inline";
  inline.type = "text/javascript";
  inline.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());`;
  document.body.appendChild(inline);
};
const pageview = (url) => {
  var _a;
  (_a = window.gtag) == null ? void 0 : _a.call(window, "config", GA_TRACKING_ID, {
    page_path: url
  });
};
const track = (action, options = {}) => {
  var _a;
  (_a = window.gtag) == null ? void 0 : _a.call(window, "event", action, {
    event_category: options.category,
    event_label: options.label,
    value: options.value
  });
};
const EVENT_ACTIONS = {
  // Settings // tbd
  SETTINGS: "SETTINGS",
  SETTINGS_SWITCH_THEME_LIGHT: "SETTINGS_SWITCH_THEME_LIGHT",
  SETTINGS_SWITCH_THEME_DARK: "SETTINGS_SWITCH_THEME_DARK",
  SETTINGS_SHARE_WITH_FRIENDS: "SETTINGS_SHARE_WITH_FRIENDS",
  SETTINGS_CONTACT_US: "SETTINGS_CONTACT_US",
  SETTINGS_PRIVACY_POLICY: "SETTINGS_PRIVACY_POLICY",
  SETTINGS_TERMS_OF_USE: "SETTINGS_TERMS_OF_USE",
  // Search
  SEARCH: "SEARCH",
  SEARCH_HIT: "SEARCH_HIT",
  TEAM_DETAILS_FROM_SEARCH: "TEAM_DETAILS_FROM_SEARCH",
  LEAGUE_DETAILS_FROM_SEARCH: "LEAGUE_DETAILS_FROM_SEARCH",
  // Dates
  ANY_DATE: "ANY_DATE",
  TODAY: "TODAY",
  // Footer
  FOOTER_MATCHES: "FOOTER_MATCHES",
  FOOTER_GOALS: "FOOTER_GOALS",
  FOOT_NEWS: "FOOT_NEWS",
  // League Details
  LEAGUE_DETAILS_FROM_MATCHES: "LEAGUE_DETAILS_FROM_MATCHES",
  LEAGUE_DETAILS_FROM_LEAGUES: "LEAGUE_DETAILS_FROM_LEAGUES",
  LEAGUE_DETAILS_FROM_LIVE: "LEAGUE_DETAILS_FROM_LIVE",
  LEAGUE_DETAILS_FROM_TEAM_FIXTURES: "LEAGUE_DETAILS_FROM_TEAM_FIXTURES",
  LEAGUE_DETAILS_FROM_TEAM_RESULTS: "LEAGUE_DETAILS_FROM_TEAM_RESULTS",
  LEAGUE_DETAILS_FROM_H2H: "LEAGUE_DETAILS_FROM_H2H",
  // Match Details
  MATCH_DETAILS_FROM_MATCHES: "MATCH_DETAILS_FROM_MATCHES",
  MATCH_DETAILS_FROM_LIVE: "MATCH_DETAILS_FROM_LIVE",
  MATCH_DETAILS_FROM_H2H: "MATCH_DETAILS_FROM_H2H",
  MATCH_DETAILS_FROM_TEAM_FIXTURES: "MATCH_DETAILS_FROM_TEAM_FIXTURES",
  MATCH_DETAILS_FROM_TEAM_RESULTS: "MATCH_DETAILS_FROM_TEAM_RESULTS",
  MATCH_DETAILS_FROM_LEAGUE_FIXTURES: "MATCH_DETAILS_FROM_LEAGUE_FIXTURES",
  MATCH_DETAILS_FROM_LEAGUE_RESULTS: "MATCH_DETAILS_FROM_LEAGUE_RESULTS",
  // Videos
  VIDEO_FROM_MATCHES: "VIDEO_FROM_MATCHES",
  VIDEO_FROM_TEAM: "VIDEO_FROM_TEAM",
  VIDEO_FROM_LEAGUE: "VIDEO_FROM_LEAGUE",
  VIDEO_FROM_GOALS: "VIDEO_FROM_GOALS",
  // Tabs - Match
  TAB_SELECTION_MATCH_TABLE: "TAB_SELECTION_MATCH_TABLE",
  TAB_SELECTION_MATCH_LINEUPS: "TAB_SELECTION_MATCH_LINEUPS",
  TAB_SELECTION_MATCH_SUMMARY: "TAB_SELECTION_MATCH_SUMMARY",
  TAB_SELECTION_MATCH_STATS: "TAB_SELECTION_MATCH_STATS",
  TAB_SELECTION_MATCH_H2H: "TAB_SELECTION_MATCH_H2H",
  TAB_SELECTION_MATCH_VIDEOS: "TAB_SELECTION_MATCH_VIDEOS",
  // Tabs - League
  TAB_SELECTION_LEAGUE_TABLE: "TAB_SELECTION_LEAGUE_TABLE",
  TAB_SELECTION_LEAGUE_RESULTS: "TAB_SELECTION_LEAGUE_RESULTS",
  TAB_SELECTION_LEAGUE_FIXTURES: "TAB_SELECTION_LEAGUE_FIXTURES",
  TAB_SELECTION_LEAGUE_PLAYER_STATS: "TAB_SELECTION_LEAGUE_PLAYER_STATS",
  TAB_SELECTION_LEAGUE_VIDEOS: "TAB_SELECTION_LEAGUE_VIDEOS",
  // Tabs - Team
  TAB_SELECTION_TEAM_SQUADS: "TAB_SELECTION_TEAM_SQUADS",
  TAB_SELECTION_TEAM_TABLE: "TAB_SELECTION_TEAM_TABLE",
  TAB_SELECTION_TEAM_RESULTS: "TAB_SELECTION_TEAM_RESULTS",
  TAB_SELECTION_TEAM_FIXTURES: "TAB_SELECTION_TEAM_FIXTURES",
  TAB_SELECTION_TEAM_PLAYER_STATS: "TAB_SELECTION_TEAM_PLAYER_STATS",
  TAB_SELECTION_TEAM_VIDEOS: "TAB_SELECTION_TEAM_VIDEOS",
  // Filters - League
  FILTER_TABLE_LEAGUE_ALL: "FILTER_TABLE_LEAGUE_ALL",
  FILTER_TABLE_LEAGUE_HOME: "FILTER_TABLE_LEAGUE_HOME",
  FILTER_TABLE_LEAGUE_AWAY: "FILTER_TABLE_LEAGUE_AWAY",
  FILTER_PLAYER_STATS_LEAGUE_ALL: "FILTER_PLAYER_STATS_LEAGUE_ALL",
  FILTER_PLAYER_STATS_LEAGUE_GOALS: "FILTER_PLAYER_STATS_LEAGUE_GOALS",
  FILTER_PLAYER_STATS_LEAGUE_ASSISTS: "FILTER_PLAYER_STATS_LEAGUE_ASSISTS",
  FILTER_PLAYER_STATS_LEAGUE_YELLOW: "FILTER_PLAYER_STATS_LEAGUE_YELLOW",
  FILTER_PLAYER_STATS_LEAGUE_RED: "FILTER_PLAYER_STATS_LEAGUE_RED",
  // Filters - Team
  FILTER_TABLE_TEAM_ALL: "FILTER_TABLE_TEAM_ALL",
  FILTER_TABLE_TEAM_HOME: "FILTER_TABLE_TEAM_HOME",
  FILTER_TABLE_TEAM_AWAY: "FILTER_TABLE_TEAM_AWAY",
  FILTER_PLAYER_STATS_TEAM_ALL: "FILTER_PLAYER_STATS_TEAM_ALL",
  FILTER_PLAYER_STATS_TEAM_GOALS: "FILTER_PLAYER_STATS_TEAM_GOALS",
  FILTER_PLAYER_STATS_TEAM_ASSISTS: "FILTER_PLAYER_STATS_TEAM_ASSISTS",
  FILTER_PLAYER_STATS_TEAM_YELLOW: "FILTER_PLAYER_STATS_TEAM_YELLOW",
  FILTER_PLAYER_STATS_TEAM_RED: "FILTER_PLAYER_STATS_TEAM_RED",
  // Filters - Match
  FILTER_TABLE_MATCH_ALL: "FILTER_TABLE_MATCH_ALL",
  FILTER_TABLE_MATCH_HOME: "FILTER_TABLE_MATCH_HOME",
  FILTER_TABLE_MATCH_AWAY: "FILTER_TABLE_MATCH_AWAY",
  // Miscellaneous
  SEND_MESSAGE: "SEND_MESSAGE",
  CHANGE_SEASON: "CHANGE_SEASON",
  TEAM_DETAILS_FROM_MATCH_DETAILS: "TEAM_DETAILS_FROM_MATCH_DETAILS",
  TEAM_DETAILS_FROM_TABLE: "TEAM_DETAILS_FROM_TABLE"
};
export {
  EVENT_ACTIONS,
  gtagInit,
  pageview,
  track
};
